// extracted by mini-css-extract-plugin
module.exports = {"root":"CardReaderDesc_root__3GiT3","col":"CardReaderDesc_col__1KBP5","label":"CardReaderDesc_label__3wRKW"};